import { StyledContainer, StyledDescription, StyledEmptyIcon } from './styled';

export interface EmptyProps {
  description?: string;
  className?: string;
}

export const Empty: React.FC<EmptyProps> = ({ description, className }) => (
  <StyledContainer className={className}>
    <StyledEmptyIcon />
    <StyledDescription>{description}</StyledDescription>
  </StyledContainer>
);
